import { FunctionComponent } from 'react';
import classnames from 'classnames';

// components
import SearchLayout from '@Components/Layout/Search';
import SearchUI from '@Components/Layout/Search/Components/SearchUI';
import LayoutContainer from '@Components/Layout/Components/Container';
import Breadcrumb, { PathLevelProps } from '@Components/UI/Breadcrumb';

// Contexts
import { withCategoryStore } from '@Components/Categories/Context';
import { ViewMedia, useViewDetected } from '@Components/Utils/ViewDetected';

// styles
import styles from './Layout.module.scss';

const paths: Array<PathLevelProps> = [
    {
        label: 'Tra cứu',
        path: '/tra-cuu',
    },
    {
        label: 'Thư viện sức khỏe',
    },
];

interface LayoutProps {
    onSearch?: (keyword: string) => void;
}

const Layout: FunctionComponent<LayoutProps> = ({ children, onSearch }) => {
    const { deviceType } = useViewDetected();

    const wrapperClassName = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
    ]);

    return (
        <SearchLayout onSearch={onSearch} placeholder="Tìm kiếm ngay..." className={wrapperClassName}>
            <LayoutContainer className={styles.breadcrumb}>
                <Breadcrumb paths={paths} />
            </LayoutContainer>

            <ViewMedia is={'desktop'}>
                <div className={styles.search_wrapper}>
                    <SearchUI
                        keyword={''}
                        onSearch={onSearch}
                        title="Thư viện sức khỏe"
                        className={styles.search}
                        placeholder="Tìm kiếm ngay..."
                        titleClassName={styles?.title}
                        subTitleClassName={styles.sub_title}
                        subTitle={'Nắm bắt các thông tin y tế, các tips sống khỏe mới nhất.'}
                    />
                </div>
            </ViewMedia>

            <div className={styles.body}>
                <LayoutContainer className={styles.layout_view}>
                    <ViewMedia is={['mobile', 'tablet']}>
                        <div className={styles.header}>
                            <div className={styles.header_title}>Thư viện sức khỏe</div>
                            <div className={styles.header_description}>Nắm bắt các tin tức y tế, các tips sống khỏe mới nhất.</div>
                        </div>
                    </ViewMedia>
                    {children}
                </LayoutContainer>
            </div>
        </SearchLayout>
    );
};

export default withCategoryStore(Layout);
